// src/api/inform.js

import Axios from "../config/axios-config";
import { downloadExcel, downloadHoldingPackagesExcel, downloadDeliveredPackagesExcel } from "../utils/downloadExcel";
import { saveAs } from "file-saver";

export const generateInformApi = async (values, type) => {
  try {
    const response = await Axios.post("reports/packages-report", values, { timeout: 0 });
    
    //console.log('Respuesta del API:', response.data); // Verifica la respuesta

    const filename =
      type === "all"
        ? "Informe Consolidado"
        : type === "client"
        ? "Informe por Cliente"
        : "Informe por Repartidor";

    // Procesar los datos
    let processedData = response.data.result.map(item => {
      // Crear un nuevo objeto sin las claves numéricas
      const cleanItem = {};
      for (const key in item) {
        if (!/^\d+$/.test(key)) { // Excluir claves que son solo números
          cleanItem[key] = item[key];
        }
      }

      // Opcional: Aplanar objetos anidados
      // const flatItem = flattenObject(cleanItem);

      // Retornar el objeto limpio (o aplanado si se usa flattenObject)
      return cleanItem; // O return flatItem;
    });

    //console.log('Datos procesados para Excel:', processedData); // Verifica los datos procesados

    if (processedData.length > 0) {
      downloadExcel({ dataToExcel: processedData, fileName: filename });
    } else {
      console.warn('No hay datos para generar el Excel.');
      // Opcional: Mostrar una notificación al usuario
    }
  } catch (err) {
    console.error('Error al generar el informe:', err);
    const errorResponse = err.response ? err.response.data : { message: err.message };
    return { error: errorResponse };
  }
};

export const generateDeliveredInformApi = async (logisticCompanyId, startDate, endDate) => {
  const values = {logisticCompanyId, startDate, endDate}
  try {
    const response = await Axios.post("reports/packages/delivered-report", values);

    const filename = "Informe de paquetes entregados";

    let processedData = response.data.map(item => {
      // Crear un nuevo objeto sin las claves numéricas
      const cleanItem = {};
      for (const key in item) {
        if (!/^\d+$/.test(key)) { // Excluir claves que son solo números
          cleanItem[key] = item[key];
        }
      }

      return cleanItem; // O return flatItem;
    });

    if (processedData.length > 0) {
      downloadDeliveredPackagesExcel({ dataToExcel: processedData, fileName: filename });
    } else {
      console.warn('No hay datos para generar el Excel.');
    }
  } catch (err) {
    console.error('Error al generar el informe:', err);
    const errorResponse = err.response ? err.response.data : { message: err.message };
    return { error: errorResponse };
  }
};

export const generateCollectReportApi = async (values) => {
  try {
    const response = await Axios.post("reports/collect",values,{responseType: "blob", timeout: 0,});

    const filename = "Informe_de_Colecta.xlsx"; // Nombre del archivo

    // Descargar el archivo Excel
    const blob = new Blob([response.data], { type: response.headers["content-type"] });
    saveAs(blob, filename);
  } catch (err) {
    console.error("Error al generar el informe Collect:", err);
    const errorResponse = err.response ? err.response.data : { message: err.message };
    return { error: errorResponse };
  }
};

export const generateCollectDetailsReportApi = async (values) => {
  try {
    const response = await Axios.post("reports/collect/detailed",values,{responseType: "blob", timeout: 0,});

    const filename = "Collect_Report_Detailed"; // Nombre del archivo

    // Descargar el archivo Excel
    const blob = new Blob([response.data], { type: response.headers["content-type"] });
    saveAs(blob, filename);
  } catch (err) {
    console.error("Error al generar el informe Collect:", err);
    const errorResponse = err.response ? err.response.data : { message: err.message };
    return { error: errorResponse };
  }
};

export const generateHoldingPackagesReport = async (holdingId, startDate, endDate) => {
  try {
    // Construir la URL con los parámetros de fecha si existen
    const queryParams = new URLSearchParams();
    if (startDate) queryParams.append("startDate", startDate);
    if (endDate) queryParams.append("endDate", endDate);

    const url = `reports/holdings/${holdingId}/packages-report?${queryParams.toString()}`;

    const response = await Axios.get(url, { timeout: 0 });

    //console.log('Respuesta del API:', response.data); // Verifica la respuesta

    const filename = `Informe_Holding_${holdingId}`;

    // A non-array body (error envelope, proxy HTML…) is treated as no data.
    const rows = Array.isArray(response.data) ? response.data : [];

    // Procesar los datos
    const processedData = rows.map(item => {
      // Crear un nuevo objeto sin las claves numéricas
      const cleanItem = {};
      for (const key in item) {
        if (!/^\d+$/.test(key)) { // Excluir claves que son solo números
          cleanItem[key] = item[key];
        }
      }
      return cleanItem;
    });

    //console.log('Datos procesados para Excel:', processedData); // Verifica los datos procesados

    if (processedData.length > 0) {
      downloadHoldingPackagesExcel({ dataToExcel: processedData, fileName: filename });
      return { empty: false };
    }

    // The endpoint answers 200 + [] when the range has no packages: an empty
    // report is not a success, so the caller must be able to tell it apart.
    return { empty: true };
  } catch (err) {
    console.error('Error al generar el informe de paquetes del holding:', err);
    const errorResponse = err.response ? err.response.data : { message: err.message };
    return { error: errorResponse };
  }
};

export const getHoldings = async () => {
  try {
    const response = await Axios.get("reports/holdings", { timeout: 0 });
    return response.data;
  } catch (err) {
    console.error('Error al obtener los holdings:', err);
    const errorResponse = err.response ? err.response.data : { message: err.message };
    return { error: errorResponse };
  }
};

export const createReportRequest = async (payload) => {
  try {
    const response = await Axios.post("reports/requests", payload);
    return response.data;
  } catch (err) {
    console.error('Error al crear solicitud de informe:', err);
    const errorResponse = err.response ? err.response.data : { message: err.message };
    return { error: errorResponse };
  }
};

export const listReportRequests = async ({ page = 1, limit = 20 } = {}) => {
  try {
    const response = await Axios.get("reports/requests", { params: { page, limit } });
    return response.data;
  } catch (err) {
    console.error('Error al listar solicitudes de informe:', err);
    const errorResponse = err.response ? err.response.data : { message: err.message };
    return { error: errorResponse };
  }
};